/**
 * The Copilot home page.
 *
 * A wrapper, since the flag that chose between two home pages is gone and
 * only one remains. Worth collapsing: App.tsx could route straight at
 * CopilotHomeV2 and this file could go.
 */
import React from 'react';
import CopilotHomeV2 from './CopilotHomeV2';

/** The home page, built from the UI kit. */
export default function CopilotHomePage() {
  return <CopilotHomeV2 />;
}
